<template>
  <router-link :to="getTo()">
  {{ this.getToLabel() }}
  </router-link>
</template>
<script>
import {getSupportedLocales} from "@/util/i18n/supported-locales";

export default {
  props: ["to"],
  methods: {
    getTo() {
      const locale = this.$route.params.locale

      return locale == 'he' ? '/en' : '/'
    },
    getToLabel() {
      const locale = this.$route.params.locale

      return locale == 'he' ? 'English' : 'עברית'
    },
  },
  data: () => ({ locales: getSupportedLocales() }),

}
</script>